
import { ref, defineComponent, toRef } from 'vue'

type PlusInfo = {
  showPlusEntrance: Boolean,
  additionalSave: Number
}

export default defineComponent({
  props: {
    plusInfo: {
      type: Object as PropType<PlusInfo>,
      default: (): PlusInfo => ({
        showPlusEntrance: false,
        additionalSave: 0,
      })
    },
  },
  setup(props, { emit }) {
    const plusInfo = toRef(props, 'plusInfo')
 
    const goVipCenter = (): void => {
      emit('goVipCenter')
    }

    return {
      goVipCenter,
    }
  },
})
